/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addVaccination } from '../fn/vaccination/add-vaccination';
import { AddVaccination$Params } from '../fn/vaccination/add-vaccination';
import { deleteVaccination } from '../fn/vaccination/delete-vaccination';
import { DeleteVaccination$Params } from '../fn/vaccination/delete-vaccination';
import { getVaccination } from '../fn/vaccination/get-vaccination';
import { GetVaccination$Params } from '../fn/vaccination/get-vaccination';
import { getVaccinationList } from '../fn/vaccination/get-vaccination-list';
import { GetVaccinationList$Params } from '../fn/vaccination/get-vaccination-list';
import { getVaccinationMap } from '../fn/vaccination/get-vaccination-map';
import { GetVaccinationMap$Params } from '../fn/vaccination/get-vaccination-map';
import { updateVaccination } from '../fn/vaccination/update-vaccination';
import { UpdateVaccination$Params } from '../fn/vaccination/update-vaccination';
import { Vaccination } from '../models/vaccination';

@Injectable({ providedIn: 'root' })
export class VaccinationService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getVaccinationList()` */
  static readonly GetVaccinationListPath = '/api/vaccination';

  /**
   * Get Vaccination List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVaccinationList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccinationList$Response(params?: GetVaccinationList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Vaccination>>> {
    return getVaccinationList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Vaccination List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVaccinationList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccinationList(params?: GetVaccinationList$Params, context?: HttpContext): Observable<Array<Vaccination>> {
    return this.getVaccinationList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Vaccination>>): Array<Vaccination> => r.body)
    );
  }

  /** Path part for operation `addVaccination()` */
  static readonly AddVaccinationPath = '/api/vaccination';

  /**
   * Add Vaccination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addVaccination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addVaccination$Response(params: AddVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
    return addVaccination(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Vaccination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addVaccination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addVaccination(params: AddVaccination$Params, context?: HttpContext): Observable<Vaccination> {
    return this.addVaccination$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vaccination>): Vaccination => r.body)
    );
  }

  /** Path part for operation `getVaccinationMap()` */
  static readonly GetVaccinationMapPath = '/api/vaccination/vaccinationmap';

  /**
   * Get Vaccination Map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVaccinationMap()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccinationMap$Response(params?: GetVaccinationMap$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: any;
}>> {
    return getVaccinationMap(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Vaccination Map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVaccinationMap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccinationMap(params?: GetVaccinationMap$Params, context?: HttpContext): Observable<{
[key: string]: any;
}> {
    return this.getVaccinationMap$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: any;
}>): {
[key: string]: any;
} => r.body)
    );
  }

  /** Path part for operation `getVaccination()` */
  static readonly GetVaccinationPath = '/api/vaccination/{vaccinationId}';

  /**
   * Get Vaccination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVaccination()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccination$Response(params: GetVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
    return getVaccination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Vaccination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVaccination$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVaccination(params: GetVaccination$Params, context?: HttpContext): Observable<Vaccination> {
    return this.getVaccination$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vaccination>): Vaccination => r.body)
    );
  }

  /** Path part for operation `updateVaccination()` */
  static readonly UpdateVaccinationPath = '/api/vaccination/{vaccinationId}';

  /**
   * Update Vaccination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVaccination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVaccination$Response(params: UpdateVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
    return updateVaccination(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Vaccination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVaccination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVaccination(params: UpdateVaccination$Params, context?: HttpContext): Observable<Vaccination> {
    return this.updateVaccination$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vaccination>): Vaccination => r.body)
    );
  }

  /** Path part for operation `deleteVaccination()` */
  static readonly DeleteVaccinationPath = '/api/vaccination/{vaccinationId}';

  /**
   * Delete Vaccination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVaccination()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVaccination$Response(params: DeleteVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
    return deleteVaccination(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Vaccination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVaccination$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVaccination(params: DeleteVaccination$Params, context?: HttpContext): Observable<Vaccination> {
    return this.deleteVaccination$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vaccination>): Vaccination => r.body)
    );
  }

}
